import { api } from "./configs/axiosConfigs";

export const TeacherWebAPI = {
  getTeachersWeb: async () => {
    const response = await api.get("/teacherWebProfile")
      .then((response) => response.data)
      .catch((error) => {
        console.log(error);
        return error.response.data;
      });
    return response;
  },
  getTeachersWebSearch: async (term) => {
    const response = await api
      .get(`/teacherWebProfile?term=${term}`)
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },
  getTeacher: async () => {
    const response = await api
      .get("/teacher")
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
      return response;
  },
  createTeacherWeb: async (data: any) => {
    const formData = new FormData();
    formData.append("teacher_id", data.teacher_id || "");
    formData.append("teacher", data.teacher || "");
    formData.append("description", data.description);
    formData.append("specialty", data.specialty);
    formData.append("linkedin_url", data.linkedin_url);
    formData.append("order", data.order || 1);
    formData.append("status", data.status);
    if (data.image instanceof File) {
      formData.append("image", data.image);
    }
    const response = await api
      .post("/teacherWebProfile", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },
  editTeacherWeb: async (id: number, data: any) => {
    const formData = new FormData();
    formData.append("teacher_id", data.teacher_id || "");
    formData.append("teacher", data.teacher || "");
    formData.append("description", data.description);
    formData.append("specialty", data.specialty);
    formData.append("linkedin_url", data.linkedin_url);
    formData.append("order", data.order || 1);
    formData.append("status", data.status);
    if (data.image instanceof File) {
      formData.append("image", data.image);
    }
    const response = await api.post(`/teacherWebProfile/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((response) => response.data).catch((error) => {
      console.error(error);
      return error.response.data;
    });
    return response;
  },
  deleteTeacherWeb: async (id: number) => {
    const response = await api
      .delete(`/teacherWebProfile/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        return error.response.data;
      });
    return response;
  },
};